export default function requiredIf(values, value, fields) {
  if (fields.some(fieldName => values[fieldName]?.length) && !value.length) {
    return false;
  }
  return true;
}
